<template>
  <div @click="handleClick">
    <input
      :accept="accept"
      :multiple="multiple"
      @change="handleChange"
      class="input-style"
      ref="input"
      type="file">
    <slot name="tip"></slot>
  </div>
</template>

<script>
import VideoUpload from '../../utils/videoupload'
import OssUpload from '../../utils/videoasyncupload'
import {isOnLine} from '../../config/constantconfig'

const uuidv1 = require('uuid/v1')

export default {
  name: 'UpLoadVideo',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    canclick: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: 'video/*'
    },
    funcallback: {
      type: Function
    },
    vidupload: {
      type: Boolean,
      default: true
    },
    videoInfix: {
      type: String,
      default: 'test/'
    },
    hasPathProName: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  methods: {
    handleClick () {
      if (!this.canclick) {
        return
      }
      this.$refs.input.click()
    },
    handleChange (e) {
      const files = e.target.files
      if (!files) {
        return
      }
      this.uploadFiles(files)
      this.$refs.input.value = null
    },
    uploadFiles (files) {
      let postFiles = Array.prototype.slice.call(files)
      if (!this.multiple) postFiles = postFiles.slice(0, 1)
      if (postFiles.length === 0) return
      let resultarray = []
      this.$emit('uploadstart')
      postFiles.forEach(file => {
        let url = URL.createObjectURL(file)
        this.upload(file).then(res => {
          res.localUrl = url
          resultarray.push(res)
          let progressdata = {
            finshnum: resultarray.length,
            totalnum: postFiles.length
          }
          this.$emit('uploadprogress', progressdata)
          if (resultarray.length === postFiles.length) {
            this.$emit('uploadSuccess', resultarray)
          }
        })
      })
    },
    upload (file) {
      let callback = (data) => {
        this.$emit('funcallback', data)
      }
      let fun = this.funcallback || callback
      if (this.vidupload) {
        let videoupload = new VideoUpload.AliOssUpload(file.name, file, fun)
        return videoupload.startUpload()
      } else {
        let uuid = uuidv1()
        let uploadPath = this.getUploadPath()
        let name = this.getFileSuffix(file.name)
        return OssUpload.multipartUpload(uploadPath + uuid + name, file, fun).then(r1 => {
          let resultinfo = {
            localfile: file,
            videoId: '',
            res: r1,
            videoUrl: (isOnLine ? 'https://video.laodao.so/' : 'https://video.test.laodao.co/') + r1.url,
          }
          return new Promise((resolve, reject) => {
            resolve(resultinfo)
          })
        }, () => {
          let errorinfo = {
            localfile: file,
            videoId: '',
            videoUrl: ''
          }
          return new Promise((resolve, reject) => {
            resolve(errorinfo)
          })
        })
      }
    },
    getUploadPath () {
      let path = 'goodsmanual/' + this.videoInfix
      if (!this.hasPathProName) {
        path = this.videoInfix
      }
      return path
    },
    getFileSuffix (name) {
      let resultstr = ''
      let index = name.lastIndexOf('.')
      if (index > 0) {
        resultstr = name.substring(index)
      }
      return resultstr
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-style {
    display: none;
  }
</style>
